<template>
  <div id="pageExplorer">
    <v-container grid-list-xs fluid>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="paginatationDisabled"
        ></v-progress-circular>
      </div>
      <div v-if="!paginatationDisabled">
        <v-card>
          <v-card-text>
            <v-form @submit.prevent="searchExplorer(1)">
              <v-layout row wrap>
                <v-flex md3 xs12>
                  <v-text-field
                    v-model="searchData.name"
                    label="Nome"
                  ></v-text-field>
                </v-flex>
                <v-flex md2 xs12>
                  <v-text-field
                    v-model="searchData.ie"
                    label="IE"
                  ></v-text-field>
                </v-flex>
                <v-flex md2 xs12>
                  <v-autocomplete
                    v-model="searchData.property_id"
                    :items="propertiesSearch"
                    item-text="name"
                    item-value="id"
                    label="Propriedade"
                    :clearable="true"
                    :loading="isLoadingPropertySearch"
                    :search-input.sync="getPropertiesSearch"
                  ></v-autocomplete>
                </v-flex>
                <v-flex md2 xs12>
                  <v-text-field
                    v-model="searchData.document_number"
                    label="CPF"
                  ></v-text-field>
                </v-flex>
                <v-flex md3 xs12>
                  <br />
                  <v-btn
                    @click="searchExplorer(1)"
                    small
                    class="ma-1"
                    color="primary"
                  >
                    <v-icon size="18" class="mr-2">fa-search</v-icon> Buscar
                  </v-btn>
                  <v-btn
                    :to="{ name: 'Explorer' }"
                    small
                    class="ma-1"
                    color="gray"
                  >
                    Limpar
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
        <br />

        <v-data-table
          v-if="explorers.data"
          :headers="headers"
          :items="explorers.data"
          :mobile-breakpoint="960"
          disable-pagination
          hide-default-footer
          disable-sort
          class="elevation-1"
        >
          <template v-slot:item.missData="{ item }">
            <div class="text-center">
              <v-tooltip bottom v-if="item.isMissingInfo">
                <template v-slot:activator="{ on }">
                  <v-icon
                    @click="editExplorer(item)"
                    style="cursor: pointer"
                    v-on="on"
                    color="red"
                    small
                  >
                    fas fa-exclamation-triangle
                  </v-icon>
                </template>
                <span>Dados incompletos</span>
              </v-tooltip>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="green" small>
                    fas fa-check
                  </v-icon>
                </template>
                <span>Dados completos</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:item.document_number="{ item }">
            {{ item.document_number | formatCpfCnpj }}
          </template>

          <template v-slot:item.created_at="{ item }">
            {{ item.created_at | formatDateHour }}
          </template>

          <template v-slot:item.updated_at="{ item }">
            {{ item.updated_at | formatDateHour }}
          </template>

          <template v-slot:item.usersCount="{ item }">
            <v-btn
              @click="listExplorerUsers(item)"
              small
              :color="item.property.usersCount > 0 ? 'success' : 'primary'"
            >
              {{ item.property.usersCount }}
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="buttons-wraps my-2">
              <v-btn color="warning" @click="editExplorer(item)">Editar</v-btn>
              <v-btn color="error" @click="deleteExplorerRequest(item)"
                >Excluir</v-btn
              >
              <v-btn color="#7030a0" @click="authorizeAccessRequest(item)"
                ><span style="color:white">Permitir Acesso</span></v-btn
              >
            </div>
          </template>

          <template v-slot:footer>
            <app-pagination
              v-if="explorers && explorers.pagination"
              :pagination="explorers.pagination"
              v-on:change-page="searchExplorer"
            ></app-pagination>
          </template>
        </v-data-table>
      </div>

      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>

      <v-dialog v-model="crud.dialog" width="500" persistent>
        <v-card>
          <v-card-title class="headline info white--text" primary-title>
            {{ crud.title }}
          </v-card-title>
          <v-card-text>
            <v-form
              ref="form"
              v-model="crud.formRule.valid"
              :lazy-validation="true"
               id="editForm"
            >
              <v-row dense>
                <v-col cols="12">
                  <v-row justify="center">
                    <span
                      v-if="errorExplorerExists"
                      class="text-center red--text mt-5"
                      >Produtor já cadastrado na propriedade selecionada</span
                    >
                  </v-row>
                  <v-autocomplete
                    v-model="crud.model.property_id"
                    :error="crud.fields.property_id"
                    :items="properties"
                    item-text="name"
                    item-value="id"
                    label="Propriedade"
                    :clearable="true"
                    :loading="isLoadingProperty"
                    :search-input.sync="getPropertiesDataSearch"
                    :rules="crud.formRule.property_id"
                    @change="clearTargetError('property_id')"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="crud.model.name"
                    :error="crud.fields.name"
                    :rules="crud.formRule.name"
                    :counter="255"
                    required
                    label="Nome"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="crud.model.document_number"
                    :error="crud.fields.document_number"
                    :rules="crud.formRule.document_number"
                    @keydown="clearTargetError('document_number')"
                    required
                    label="CPF/CNPJ"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    class="chebox-isento"
                    v-model="crud.model.ce_free"
                    label="Sou isento de Código de Estabalecimento"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-if="!crud.model.ce_free"
                    v-model="crud.model.establishment_code"
                    :disabled="crud.model.ce_free"
                    :error="crud.fields.establishment_code"
                    :rules="crud.formRule.establishment_code"
                    @keydown="clearTargetError('establishment_code')"
                    required
                    label="Código do estabelecimento"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    class="chebox-isento"
                    v-model="crud.model.ie_free"
                    label="Sou isento de Inscrição Estadual"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-if="!crud.model.ie_free"
                    v-model="crud.model.ie"
                    :disabled="crud.model.ie_free"
                    :rules="crud.formRule.ie"
                    :error="crud.fields.ie"
                    @keydown="clearTargetError('ie')"
                    required
                    label="IE (Inscrição Estadual)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn outlined @click="crud.dialog = false">
              Cancelar
            </v-btn>
            <v-btn
              color="green"
              dark
              @click="saveExplorer"
              :loading="crud.saving"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbarSave" color="success">
        Salvo com sucesso!
        <v-btn text @click="snackbarSave = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-snackbar>

      <v-snackbar v-model="snackbarError" color="error">
        Já existe um produtor cadastrado com os dados informados.
        <v-btn text @click="snackbarError = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-snackbar>

      <v-btn absolute dark fab top right color="orange" @click="newExplorer">
        <v-icon>add</v-icon>
      </v-btn>
    </v-container>

    <v-dialog v-model="dialogDeleteExplorer" max-width="500">
      <v-card>
        <v-card-title class="headline">Atenção!</v-card-title>

        <v-card-text>
          Você realmente deseja deletar o produtor
          {{ this.targetExplorerToDelete.name }}?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="deleteExplorerSuccess">
            Sim
          </v-btn>

          <v-btn color="primary" text @click="dialogDeleteExplorer = false">
            Não
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAuthorizeAccess" max-width="500">
      <v-card>
        <v-card-title class="headline">Permitir acesso</v-card-title>

        <v-card-text>
          Você deseja dar acesso para qual usuário?
        </v-card-text>

        <v-card-text>
          <v-autocomplete
            @change="formGiveAccess.userError = false"
            v-model="userSelected"
            :items="users"
            :error="formGiveAccess.userError"
            :rules="formGiveAccess.userRules"
            :loading="isLoadingUser"
            :search-input.sync="getUsers"
            clearable
            hide-details
            hide-no-data
            hide-selected
            item-value="id"
            item-text="email"
            label="E-mail do usuário"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="authorizeAccessSuccess">
            Salvar
          </v-btn>

          <v-btn color="primary" text @click="dialogAuthorizeAccess = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUsersAllowed" max-width="500">
      <v-card>
        <v-card-title class="headline">Usuários Permitidos</v-card-title>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Nome</th>
                  <th class="text-left">E-mail</th>
                  <th class="text-left">Telefone</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in usersAllowed" :key="user.email">
                  <td>{{ user.name }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.phone }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" text @click="dialogUsersAllowed = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import appApi from "@/plugins/api";
import AppPagination from "@/components/Pagination";
import ConfirmModal from "@/components/ConfirmModal";
import moment from "moment";

export default {
  components: {
    "app-pagination": AppPagination,
    "app-confirm-modal": ConfirmModal
  },
  data: function() {
    return {
      headers: [
        { text: "", value: "missData", sortable: false },
        { text: "Nome", value: "name", sortable: false },
        { text: "CPF/CNPJ", value: "document_number", sortable: false },
        { text: "IE", value: "ie", sortable: false },
        { text: "Propriedade", value: "property.name", sortable: false },
        {
          text: "Cod. Estabelecimento",
          value: "establishment_code",
          sortable: false
        },
        { text: "Data Cadastro", value: "created_at", sortable: false },
        { text: "Data Alteração", value: "updated_at", sortable: false },
        { text: "Usuários", value: "usersCount", sortable: false },
        { text: "Ações", value: "actions", sortable: false }
      ],
      dialogUsersAllowed: false,
      hover: false,
      usersAllowed: [],
      formGiveAccess: {
        usersRules: [v => !!v || "Usuário é obrigatório"],
        valid: true,
        userError: false
      },
      isLoadingUser: false,
      explorerSelected: {},
      dialogAuthorizeAccess: false,
      users: [],
      userSelected: null,
      dialogDeleteExplorer: false,
      targetExplorerToDelete: {},
      explorers: {},
      snackbarSave: false,
      snackbarError: false,
      paginatationDisabled: false,
      errorExplorerExists: false,
      crud: {
        saving: false,
        model: {
          property_id: "",
          name: "",
          document_number: "",
          establishment_code: "",
          ie: "",
          ie_free: false,
          ce_free: false
        },
        fields: {
          property_id: false,
          name: false,
          document_number: false,
          establishment_code: false,
          ie: false
        },
        dialog: false,
        title: "Adicionar Produtor",
        formRule: {
          valid: true,
          property_id: [v => !!v || "Propriedade é obrigatório"],
          name: [
            v => !!v || "Nome é obrigatório",
            v =>
              v.length < 256 ||
              "Nome tem quer ser menor ou igual as 255 caracteres"
          ],
          document_number: [v => !!v || "CPF/CNPJ é obrigatório"],
          establishment_code: [
            v => !!v || "Código do estabelecimento é obrigatório"
          ],
          ie: [v => !!v || "IE é obrigatório"]
        }
      },
      snackbar: false,
      getProperties: null,
      getPropertiesSearch: null,
      getUsers: null,
      properties: [],
      propertiesSearch: [],
      isLoadingPropertySearch: false,
      isLoadingProperty: false,
      searchData: {}
    };
  },

  computed: {},

  mounted: function() {
    window.scrollTo(0, 0);

    this.loadInitialData();
  },

  methods: {
    loadInitialData() {
      if (this.$route.query.page) {
        this.searchData["page"] = this.$route.query.page;
      } else {
        this.searchData["page"] = 1;
      }

      if (this.$route.query.name) {
        this.searchData["name"] = this.$route.query.name;
      }
      if (this.$route.query.document_number) {
        this.searchData["document_number"] = this.$route.query.document_number;
      }
      if (this.$route.query.property_id) {
        this.searchData["property_id"] = this.$route.query.property_id;
      }
      if (this.$route.query.ie) {
        this.searchData["ie"] = this.$route.query.ie;
      }
      this.getExplorers(this.searchData);
      this.getPropertiesData();
      this.getPropertiesDataSearch();
    },
    listExplorerUsers(item) {
      if (+item.property.usersCount === 0) {
        return;
      }

      this.dialogUsersAllowed = true;
      appApi
        .getExplorerUsers({ propertyId: item.property.id })
        .then(res => (this.usersAllowed = res.data.data));
    },

    authorizeAccessSuccess() {
      if (!this.userSelected) {
        return;
      }

      appApi
        .postExplorerUsers({
          explorer_id: this.explorerSelected.id,
          user_id: this.userSelected
        })
        .then(res => {
          this.snackbar = {
            color: "success",
            show: true,
            text: "Usuário autorizado com sucesso!"
          };
          this.dialogAuthorizeAccess = false;
          this.userSelected = null;

          this.loadInitialData();
        })
        .catch(err => {
          if (err.response.status === 400) {
            this.snackbar = {
              color: "error",
              show: true,
              text: err.response.data.error.message
            };

            this.formGiveAccess.userError = true;
          }
        });
    },
    authorizeAccessRequest(item) {
      this.dialogAuthorizeAccess = true;
      this.explorerSelected = item;
      this.userSelected = null;
    },
    deleteExplorerSuccess() {
      appApi.deleteExplorer(this.targetExplorerToDelete.id).then(res => {
        this.snackbar = {
          color: "success",
          show: true,
          text: "Explorador deletado com sucesso!"
        };

        this.dialogDeleteExplorer = false;
        this.loadInitialData();
      });
    },
    deleteExplorerRequest(item) {
      this.dialogDeleteExplorer = true;
      this.targetExplorerToDelete = item;
    },

    searchExplorer: function(page) {
      let data = { page: page ? page : 1 };

      if (this.searchData.document_number) {
        data["document_number"] = this.searchData.document_number.replace(
          /\D/g,
          ""
        );
      }
      if (this.searchData.name) {
        data["name"] = this.searchData.name;
      }

      if (this.searchData.property_id) {
        data["property_id"] = this.searchData.property_id;
      }

      if (this.searchData.ie) {
        data["ie"] = this.searchData.ie;
      }
      this.$router.push({ name: "Explorer", query: data });
    },

    getExplorers: function(data) {
      this.paginatationDisabled = true;
      this.explorers.data = [];
      appApi
        .getExplorers(data)
        .then(result => {
          this.explorers = result.data;
          this.paginatationDisabled = false;
          for (var i = 0; i < this.explorers.data.length; i++) {
            this.explorers.data[i].name = this.explorers.data[
              i
            ].name.toLowerCase();
            this.explorers.data[i].property.name = this.explorers.data[
              i
            ].property.name.toLowerCase();
          }
        })
        .catch(error => {
          this.paginatationDisabled = false;
          this.explorers.data = [];
        });
    },

    clearErrors() {
      if (this.errorExplorerExists) {
        this.errorExplorerExists = false;
      }

      for (let key in this.crud.fields) {
        this.crud.fields[key] = false;
      }
    },

    clearTargetError(target) {
      this.crud.fields[target] = false;
      this.crud.fields["property_id"] = false;
      this.errorExplorerExists = false;
    },

    editExplorer(item) {
      this.clearErrors();
      this.crud.title = "Editar Produtor";
      this.crud.model = item;
      this.crud.formRule.valid = true;
      this.crud.dialog = true;
    },

    newExplorer() {
      this.clearErrors();
      this.crud.title = "Adicionar Produtor";
      this.crud.model = {
        property_id: "",
        name: "",
        document_number: "",
        establishment_code: "",
        ie: "",
        ce_free: false,
        ie_free: false
      };
      this.crud.formRule.valid = true;
      this.crud.dialog = true;
    },

    saveSuccess(data) {
      this.clearErrors();
      this.crud.saving = false;
      this.crud.model = data;
      this.snackbarSave = true;
      this.crud.dialog = false;
      this.getExplorers();
    },

    errorSave(result) {
      this.clearErrors();
      this.crud.saving = false;
      if (result.response && result.response.status == 500) {
        this.snackbarError = true;
      } else if (result.response && result.response.status == 400) {
        result.response.data.forEach(element => {
          this.crud.fields[element.field] = true;

          if (element.field === "property_id") {
            this.errorExplorerExists = true;
            this.crud.fields["document_number"] = true;
            this.crud.fields["establishment_code"] = true;
            this.crud.fields["ie"] = true;
          }
        });
      }
    },

    saveExplorer() {
      this.clearErrors();
      if (this.$refs.form.validate()) {
        this.crud.saving = true;
        if (this.crud.model.id) {
          appApi
            .putExplorer(this.crud.model.id, this.crud.model)
            .then(result => {
              this.saveSuccess(result.data);
            })
            .catch(error => {
              this.errorSave(error);
            });
        } else {
          appApi
            .postExplorer(this.crud.model)
            .then(result => {
              this.saveSuccess(result.data);
            })
            .catch(error => {
              this.errorSave(error);
            });
        }
      }
    },

    getPropertiesData(name) {
      // Items have already been requested
      if (this.isLoadingProperty) return;

      this.isLoadingProperty = true;

      var data = {};
      if (name && name.trim().length > 0) {
        data["name"] = name.trim();
      }

      appApi
        .getProperties(data)
        .then(result => {
          this.properties = result.data.data;
          this.countProperties = result.data.pagination.total;
        })
        .finally(() => (this.isLoadingProperty = false));
    },
    getPropertiesDataSearch(name) {
      // Items have already been requested
      if (this.isLoadingPropertySearch) return;

      this.isLoadingPropertySearch = true;

      var data = {};
      if (name && name.trim().length > 0) {
        data["name"] = name.trim();
      }

      appApi
        .getProperties(data)
        .then(result => {
          this.propertiesSearch = result.data.data;
        })
        .finally(() => (this.isLoadingPropertySearch = false));
    }
  },

  watch: {
    getProperties(name) {
      this.getPropertiesData(name);
    },
    getPropertiesSearch(name) {
      this.getPropertiesDataSearch(name);
    },
    getUsers(email) {
      this.isLoadingUsers = true;

      if (email === "" || !email) {
        return;
      }

      appApi.getUsers({ fullemail: email }).then(result => {
        this.users = result.data.data;
      });

      this.isLoadingUsers = false;
    }
  }
};
</script>
<style scoped lang="scss">
#pageExplorer::v-deep {
  position: relative;


  .v-data-table-header.v-data-table-header-mobile {
    display: none !important;
  }

  .buttons-wraps {
    display: flex;
    justify-content: space-around;
    min-width: 400px;

    @media screen and (min-width: 600px) and (max-width: 1100px) {
      flex-direction: column;
      min-width: initial;

      .v-btn {
        margin: 5px 20px;
      }
    }

    @media screen and (min-width: 600px) and (max-width: 960px) {
      .v-btn {
        margin: 5px 0;
      }
    }

    @media screen and (max-width: 450px) {
      flex-direction: column;
      min-width: initial;

      .v-btn {
        margin: 5px 0;
      }
    }
  }

  @media screen and (min-width: 600px) and (max-width: 1100px) {
    .v-data-table td {
      height: auto;
      min-height: 48px;
    }
  }

  @media screen and (max-width: 960px) {
    .v-data-table tr {
      display: block;
      padding-top: 24px;
    }
  }

  @media screen and (max-width: 450px) {
    .v-data-table td {
      height: auto;
      min-height: 48px;
    }
  }
}

#editForm::v-deep {
  .chebox-isento {
    margin-top: 0;
    padding-top: 0;
    
    .v-input__slot {
      margin-bottom: 0;
    }

    .v-messages {
      display: none;
    }
  }
}

#pageExplorer >>> .v-data-table-header.v-data-table-header-mobile {
  display: none !important;
}
</style>

<style lang="scss">
#pageExplorer {
  .text-start,
  .v-data-table__mobile-row__cell {
    text-transform: capitalize;
  }

}


</style>
